import productReviewService from './ProductReviewService'

export default productReviewService
